import utility from 'src/utils/utility'
import {
    FiHeadphones, FiFileText, FiPlayCircle, FiMessageSquare, FiArrowRight, FiArrowUpRight,
} from 'react-icons/fi'
import {
    Card, Text, Flex, Box, tokens,
} from 'src/componentv2'
import { fontBold, fontMedium, fontRegular } from 'src/model/v2/interface/constants'
interface ResourceLink {
    key: string
    icon: React.ReactNode
    title: string
    description: string
    linkLabel: string
    arrow: 'right' | 'diagonal'
    onClick: () => void
}

const HelpAndResources = () => {
    const resources: ResourceLink[] = [
        {
            key: 'contact-support',
            icon: <FiHeadphones size={22} color={tokens.primary} />,
            title: 'Contact support',
            description: 'No spam. Just the latest releases and tips, interesting',
            linkLabel: 'View support contact',
            arrow: 'right',
            onClick: () => {},
        },
        {
            key: 'video-guides',
            icon: <FiPlayCircle size={22} color={tokens.primary} />,
            title: 'Video Guides',
            description: 'No spam. Just the latest releases and tips, interesting',
            linkLabel: 'Access video guides',
            arrow: 'diagonal',
            onClick: () => {},
        },
        {
            key: 'help-articles',
            icon: <FiFileText size={22} color={tokens.primary} />,
            title: 'Help Articles',
            description: 'No spam. Just the latest releases and tips, interesting',
            linkLabel: 'Access help articles',
            arrow: 'diagonal',
            onClick: () => {},
        },
        {
            key: 'share-feedback',
            icon: <FiMessageSquare size={22} color={tokens.primary} />,
            title: 'Share Feedback',
            description: 'No spam. Just the latest releases and tips, interesting',
            linkLabel: 'Open form',
            arrow: 'right',
            onClick: () => {},
        },
    ]

    return (
        <div>
                <div style={{ padding: '2.4rem 3.2rem' }}>
                    <Flex justify="space-between" items="flex-start">
                        <Box>
                            <Text fontSize="2.4" style={fontBold} color={tokens.textDark}>
                                Help &amp; Resources
                            </Text>
                        </Box>
                    </Flex>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(24rem, 1fr))',
                            gap: '2rem',
                            marginTop: '2.4rem',
                        }}
                    >
                        {resources.map((resource) => (
                            <Card
                                key={resource.key}
                                padding="2.4"
                                radius="1.2"
                                borderColor={tokens.border}
                                shadow={tokens.shadowCard}
                            >
                                <Box
                                    bgColor={tokens.primarySoft}
                                    radius="1"
                                    width="4.8"
                                    height="4.8"
                                >
                                    <Flex justify="center" width="100%" height="100%">
                                        {resource.icon}
                                    </Flex>
                                </Box>

                                <Text
                                    fontSize="1.7"
                                    style={fontMedium}
                                    color={tokens.textDark}
                                    topMargin="1.6"
                                >
                                    {resource.title}
                                </Text>

                                <Text
                                    fontSize="1.4"
                                    style={fontRegular}
                                    color={tokens.textMuted}
                                    topMargin="0.6"
                                >
                                    {resource.description}
                                </Text>

                                <button
                                    type="button"
                                    onClick={resource.onClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.6rem',
                                        marginTop: '1.6rem',
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        cursor: 'pointer',
                                        color: tokens.helplink,
                                        fontSize: '1.4rem',
                                        ...fontMedium,
                                    }}
                                >
                                    {resource.linkLabel}
                                    {resource.arrow === 'right' ? <FiArrowRight /> : <FiArrowUpRight />}
                                </button>
                            </Card>
                        ))}
                    </div>
                </div>
        </div>
    )
}

export default utility.routeData('help-resources', 'Help & Resources', <HelpAndResources />)